export function get_doc_title() {
  let env = 'local'

  if (typeof window !== 'undefined') {
    if (window.location.hostname.indexOf('rbt-viewer.') !== -1) {
      env = 'final'
    } else if (window.location.hostname.indexOf('rbt-viewer-dev.') !== -1) {
      env = 'dev'
    }
  }

  return `royal botania frontend (${env})`
}
